import { Extension } from "@tiptap/core";

export const HardBreakOnEnter = Extension.create({
  name: "hardBreakOnEnter",

  addKeyboardShortcuts() {
    return {
      Enter: () => {
        return this.editor.commands.setHardBreak();
      },
    };
  },
});
